import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import './Select.scss';

const cx = (...classes) => classes.filter(Boolean).join(' ');

const Select = forwardRef(({
  size = 'md',
  invalid = false,
  fullWidth = true,
  placeholder,
  children,
  className = '',
  selectClassName = '',
  disabled,
  value,
  ...props
}, ref) => (
  <span
    className={cx(
      'reops-select',
      `reops-select--${size}`,
      invalid && 'is-invalid',
      disabled && 'is-disabled',
      fullWidth && 'reops-select--full',
      className,
    )}
  >
    <select
      ref={ref}
      className={cx('reops-select__control', !value && placeholder && 'is-placeholder', selectClassName)}
      disabled={disabled}
      value={value}
      {...props}
    >
      {placeholder ? <option value="">{placeholder}</option> : null}
      {children}
    </select>
    <span className="reops-select__icon" aria-hidden="true">
      <ChevronDown size={20} strokeWidth={1.8} />
    </span>
  </span>
));

Select.displayName = 'Select';

export default Select;
